import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout, map, catchError } from 'rxjs/operators';
import { DataStoreService } from './data-store.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { empty, TimeoutError } from 'rxjs';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {

  constructor(
    private DataStore: DataStoreService,
    private spinner: NgxSpinnerService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      timeout(60000),
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        this.DataStore.onNotify(true)
        this.spinner.hide();
        if (err instanceof TimeoutError)
          console.error('Timeout has occurred', request.url);
        return empty();
      })
    );
  }
}
